module.exports = __webpack_public_path__ + "static/instagram-icon-black-a0cf419b8152b11e3ff55f199559717b.png";